import { Link, useLocation } from 'react-router-dom'
import { BookOpenCheck, Home, LogOut, Menu, Users, X } from 'lucide-react'
import { useState } from 'react'
import { toast } from 'sonner'
import { useAuth } from '@/hooks/useAuth'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

const navItems = [
  { to: '/', label: 'Home', icon: Home },
  { to: '/booked-out', label: 'Bookings', icon: BookOpenCheck },
  { to: '/friends', label: 'Friends', icon: Users },
]

export const Header = () => {
  const location = useLocation()
  const { signOut } = useAuth()
  const [menuOpen, setMenuOpen] = useState(false)

  const handleSignOut = async () => {
    const { error } = await signOut()

    if (error) {
      toast.error(error.message)
    }

    setMenuOpen(false)
  }

  return (
    <header className='sticky top-0 z-40 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80'>
      <div className='mx-auto flex w-full max-w-5xl items-center justify-between gap-2 p-3 sm:p-4'>
        <div className='flex items-center gap-2 text-sm font-semibold'>Booky</div>

        <nav className='hidden items-center gap-2 sm:flex'>
          {navItems.map((item) => {
            const Icon = item.icon
            return (
              <Link
                key={item.to}
                to={item.to}
                className={cn(
                  'inline-flex items-center gap-2 rounded-md px-3 py-2 text-sm whitespace-nowrap text-muted-foreground hover:bg-accent hover:text-accent-foreground',
                  location.pathname === item.to && 'bg-accent text-accent-foreground',
                )}
              >
                <Icon className='h-4 w-4' />
                {item.label}
              </Link>
            )
          })}
          <Button variant='outline' size='sm' onClick={handleSignOut} className='hidden sm:inline-flex'>
            <LogOut className='mr-2 h-4 w-4' />
            Sign out
          </Button>
        </nav>
        <Button
          variant='outline'
          size='sm'
          className='sm:hidden'
          onClick={() => setMenuOpen((open) => !open)}
          aria-label='Toggle navigation menu'
        >
          {menuOpen ? <X className='h-4 w-4' /> : <Menu className='h-4 w-4' />}
        </Button>
      </div>

      {menuOpen && (
        <div className='border-t bg-background sm:hidden'>
          <nav className='mx-auto grid w-full max-w-5xl gap-2 p-3'>
            {navItems.map((item) => {
              const Icon = item.icon
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  onClick={() => setMenuOpen(false)}
                  className={cn(
                    'inline-flex items-center gap-2 rounded-md px-3 py-2 text-sm text-muted-foreground hover:bg-accent hover:text-accent-foreground',
                    location.pathname === item.to && 'bg-accent text-accent-foreground',
                  )}
                >
                  <Icon className='h-4 w-4' />
                  {item.label}
                </Link>
              )
            })}
            <Button
              variant='ghost'
              size='sm'
              onClick={handleSignOut}
              className='h-auto w-full justify-start rounded-md px-3 py-2 text-sm font-normal text-muted-foreground underline-offset-4 hover:bg-accent hover:text-accent-foreground hover:underline'
            >
              <LogOut className='h-4 w-4' />
              Sign out
            </Button>
          </nav>
        </div>
      )}
    </header>
  )
}
